import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import {
  clickableFrameLinkStyles,
  clickableFrameStyles,
} from "scmp-app/components/content/content-item-render/clickable-frame/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  ${clickableFrameLinkStyles}
  display: flex;
  flex-direction: row;
  gap: 12px;

  color: #000000;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: column;
  }
`;

export const Container = styled.div`
  ${clickableFrameStyles(StyledEntityLink)}
`;

export const TextGroup = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 8px;

  min-inline-size: 0;
`;

export const SectionLabel = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  text-transform: uppercase;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: 130%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 15px;
  }
`;

export const SponsorBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SponsorType = styled.span`
  align-self: flex-start;

  padding-block-start: 8px;

  border-block-start: 1px solid #dfdfdf;

  color: #727272;
  font-size: 10px;
  font-family: ${fontRoboto};
`;

export const SponsorName = styled.span`
  color: #333333;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
`;

export const CoverImage = styled.div`
  flex-shrink: 0;

  inline-size: 100px;
  block-size: auto;

  ${Figure} {
    aspect-ratio: 3 / 2;
  }

  ${theme.breakpoints.only("mobile")} {
    min-inline-size: 100px;
    max-inline-size: 160px;
    min-block-size: 66.667px;
    max-block-size: 106.667px;
  }
`;
